import { Injectable } from '@angular/core';
import { HeaderHelperService } from '../header-helper.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService
  ) {}

  dashboardCountInformations(): Observable<any> {
    let url = `${environment.apiLocations.patient}/Dashboard/GetDashboardCountInformation`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }
}
